import { QuestionIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const QuestionCircle = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <QuestionIcon size={Sizes[size]} {...rest} fill={fill} />;
};

QuestionCircle.displayName = 'QuestionCircle';
